(function () {
  'use strict';

  var configElement = document.getElementById('mndj-noel-config');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  var dates = config.dates || {};
  var required = ['start', 'custom', 'express', 'standardFr', 'standardIntl', 'end'];
  var validIso = function (value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    var parts = value.split('-').map(Number);
    var check = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
    return check.getUTCFullYear() === parts[0] &&
      check.getUTCMonth() + 1 === parts[1] &&
      check.getUTCDate() === parts[2];
  };
  if (!required.every(function (key) { return validIso(dates[key]); })) return;
  if (!(dates.start <= dates.custom &&
    dates.custom <= dates.express &&
    dates.express <= dates.standardFr &&
    dates.custom <= dates.standardIntl &&
    dates.standardFr <= dates.end &&
    dates.standardIntl <= dates.end)) return;

  var locale = String(config.locale || 'fr').toLowerCase();
  var frenchCopy = locale.indexOf('fr') === 0;
  var france = frenchCopy && config.country === 'FR';
  var language = frenchCopy ? 'fr-FR' : 'en-US';
  var requestedDate = new URLSearchParams(window.location.search).get('noel_date');
  var previewSelector = 'iframe[src*="/preview-bar/"], #shopify-preview-bar';
  var preview = function () {
    return Boolean((window.Shopify && window.Shopify.designMode === true) ||
      document.querySelector(previewSelector));
  };
  var parisToday = function () {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    var value = {};
    parts.forEach(function (part) { value[part.type] = part.value; });
    return value.year + '-' + value.month + '-' + value.day;
  };
  var activeDate = function () {
    return validIso(requestedDate) && preview() ? requestedDate : parisToday();
  };
  var formatDate = function (value) {
    var parts = value.split('-').map(Number);
    return new Intl.DateTimeFormat(language, {
      timeZone: 'Europe/Paris',
      day: 'numeric',
      month: 'long'
    }).format(new Date(Date.UTC(parts[0], parts[1] - 1, parts[2], 12)));
  };
  var escapeHtml = function (value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character];
    });
  };
  var labels = {
    '%CUSTOM_DATE%': escapeHtml(formatDate(dates.custom)),
    '%EXPRESS_DATE%': escapeHtml(formatDate(dates.express)),
    '%STANDARD_DATE%': escapeHtml(formatDate(france ? dates.standardFr : dates.standardIntl))
  };
  var message = function (key) {
    var value = String((config.messages || {})[key] || '');
    Object.keys(labels).forEach(function (token) {
      value = value.split(token).join(labels[token]);
    });
    return value;
  };
  var setMessage = function (element, key) {
    if (!element) return;
    var html = key ? message(key) : '';
    if (!html) {
      element.hidden = true;
      return;
    }
    if (element.innerHTML !== html) element.innerHTML = html;
    element.hidden = false;
  };
  var phase = function (today) {
    if (today < dates.start || today > dates.end) return '';
    if (today <= dates.custom) return 'early';
    if (france && today <= dates.express) return 'express';
    if (today <= (france ? dates.standardFr : dates.standardIntl)) return 'standard';
    return 'late';
  };
  var discountBar = document.querySelector('.announcement-bar announcement-bar');
  var christmasBar = document.querySelector('[data-mndj-noel="banner"]');
  var shortText = christmasBar && christmasBar.querySelector('[data-mndj-noel-short]');
  var longText = christmasBar && christmasBar.querySelector('[data-mndj-noel-long]');
  var bannerTimer;
  var bannerState = '';
  var paused = false;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var showChristmas = function (show) {
    if (!discountBar || !christmasBar) return;
    discountBar.hidden = show;
    christmasBar.hidden = !show;
  };
  var updateBanner = function (period) {
    if (!discountBar || !christmasBar) return;
    var nextState = period + ':' + (france ? 'fr' : 'intl');
    if (nextState === bannerState) return;
    bannerState = nextState;
    window.clearInterval(bannerTimer);
    if (!period) {
      showChristmas(false);
      return;
    }
    var prefix = france ? 'banner_' : 'banner_intl_';
    var key = period === 'early' ? 'early' :
      period === 'express' ? 'express' :
      period === 'standard' ? 'standard' : 'late';
    if (period === 'late') prefix = 'banner_';
    if (!france && period === 'standard') prefix = 'banner_intl_';
    setMessage(shortText, prefix + key + '_short_html');
    setMessage(longText, prefix + key + '_long_html');
    showChristmas(true);
    if (reduceMotion) {
      discountBar.hidden = false;
      return;
    }
    bannerTimer = window.setInterval(function () {
      if (!paused) showChristmas(christmasBar.hidden);
    }, 7000);
  };
  var bannerParent = christmasBar && christmasBar.parentElement;
  if (bannerParent) {
    bannerParent.addEventListener('mouseenter', function () { paused = true; });
    bannerParent.addEventListener('mouseleave', function () { paused = false; });
    bannerParent.addEventListener('focusin', function () { paused = true; });
    bannerParent.addEventListener('focusout', function () { paused = false; });
  }

  var cartKey = function (period, hasCustom) {
    if (hasCustom) {
      if (period === 'early') return 'cart_custom_early_html';
      if (france && period === 'express') return 'cart_custom_express_html';
      return 'cart_custom_after_html';
    }
    var before = period !== 'late';
    if (france) return before ? 'cart_standard_before_html' : 'cart_standard_after_html';
    return before ? 'cart_standard_intl_before_html' : 'cart_standard_intl_after_html';
  };
  var renderCart = function (period, cart) {
    document.querySelectorAll('[data-mndj-noel="cart"]').forEach(function (element) {
      var count = cart && typeof cart.item_count === 'number' ?
        cart.item_count : Number(element.getAttribute('data-cart-count') || 0);
      if (!period || count < 1) {
        setMessage(element, '');
        return;
      }
      var hasCustom = cart && Array.isArray(cart.items) ?
        cart.items.some(function (item) {
          return String(item.product_id) === String(config.customProductId);
        }) : element.getAttribute('data-has-custom') === 'true';
      setMessage(element, cartKey(period, hasCustom));
    });
  };
  var currentPeriod = '';
  var render = function (cart) {
    currentPeriod = phase(activeDate());
    updateBanner(currentPeriod);
    var standardKey = currentPeriod === 'late' ? 'standard_after_html' : 'standard_before_html';
    if (!france) standardKey = currentPeriod === 'late' ?
      'standard_intl_after_html' : 'standard_intl_before_html';
    document.querySelectorAll('[data-mndj-noel="standard"]').forEach(function (element) {
      setMessage(element, currentPeriod ? standardKey : '');
    });
    var customKey = '';
    if (currentPeriod === 'early') customKey = france ? 'custom_early_html' : 'custom_intl_early_html';
    else if (currentPeriod === 'express') customKey = 'custom_express_html';
    else if (currentPeriod === 'standard') customKey = france ?
      'custom_after_standard_html' : 'custom_intl_after_html';
    else if (currentPeriod === 'late') customKey = 'custom_late_html';
    document.querySelectorAll('[data-mndj-noel="custom"]').forEach(function (element) {
      setMessage(element, customKey);
    });
    renderCart(currentPeriod, cart);
  };
  render();
  window.setInterval(function () { render(); }, 60000);
  document.addEventListener('cart:updated', function (event) {
    renderCart(currentPeriod, event.detail && event.detail.cart);
  });
  var cartObserver = new MutationObserver(function (mutations) {
    var changed = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 && (node.matches('[data-mndj-noel="cart"]') ||
          (node.querySelector && node.querySelector('[data-mndj-noel="cart"]')));
      });
    });
    if (changed) renderCart(currentPeriod);
  });
  cartObserver.observe(document.body, {childList: true, subtree: true});
  if (requestedDate && validIso(requestedDate) && !preview()) {
    var previewObserver = new MutationObserver(function () {
      if (preview()) {
        previewObserver.disconnect();
        render();
      }
    });
    previewObserver.observe(document.documentElement, {childList: true, subtree: true});
    window.setTimeout(function () { previewObserver.disconnect(); }, 10000);
  }
})();
